/* React base class */
import { Component } from "react"

/* Redux store connection */
import { connect } from "react-redux"

/* Router HOC */
import { withRouter, applySeo } from "../helpers"

/* Shared UI components */
import { Block } from "../components"

/* Icon component */
import Icon from "../components/Icon"

/* i18n */
import { translate } from "../translates"

const STATS = [
    { n: "200+", l: "салонов и мастеров" },
    { n: "3 000+", l: "записей в месяц" },
    { n: "1", l: "город Казахстана" },
    { n: "4.8", l: "средняя оценка сервиса" }
]

const VALUES = [
    { icon: "clock", t: "Запись за минуту", d: "Выбрали услугу, мастера и время — подтверждение приходит сразу. Без звонков и переписок." },
    { icon: "star", t: "Только проверенные", d: "Реальные отзывы после визита, честные рейтинги и фотографии работ от клиентов." },
    { icon: "heart", t: "Забота о клиенте", d: "Напоминания о записи, лёгкий перенос и отмена, поддержка на связи каждый день." },
    { icon: "settings", t: "Удобно для бизнеса", d: "Онлайн-расписание, база клиентов и аналитика — всё, чтобы салон рос быстрее." }
]

/* Page About */
class About extends Component {

    componentDidMount = () => {

        /* SEO */
        applySeo({
            title: "О Bookify — платформа онлайн-записи в Казахстане",
            description: "Bookify — казахстанская платформа онлайн-записи на услуги: салоны красоты, барбершопы, автомойки и другие сервисы. Узнайте о компании, миссии и возможностях платформы.",
            path: "/about"
        })

        /* Scroll */
        window.scroll(0, 0)
    }

    /* Draw Hero */
    _hero = () => {

        /* Fields */
        const { navigate } = this.props

        return (
            <section className="about__hero">
                <div className="container about__hero-inner">
                    <div className="about__hero-text">
                        <div className="about__eyebrow">{translate("О компании")}</div>
                        <h1 className="about__title">
                            {translate("Записывайтесь|за пару кликов").split("|").map((line, index) => (
                                <span key={`${index}`}>{index > 0 ? <br /> : null}{line}</span>
                            ))}
                        </h1>
                        <p className="about__lede">
                            {translate("Bookify — это платформа онлайн-записи в салоны красоты, барбершопы, SPA и автосервисы Казахстана. Мы помогаем людям находить лучших мастеров рядом, а бизнесу — расти и принимать клиентов без хаоса в расписании.")}
                        </p>
                        <div className="about__hero-cta">
                            <button className="btn btn--lg" onClick={() => navigate("/")}>
                                {translate("Найти услугу")} <Icon name="arrow_right" size={16} />
                            </button>
                            <button className="btn btn--ghost btn--lg" onClick={() => window.open("/partnership", "_blank")}>
                                {translate("Подключить салон")}
                            </button>
                        </div>
                    </div>
                    <div className="about__hero-media">
                        <img src="https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=900&q=80" alt="" />
                        <div className="about__hero-badge">
                            <span className="about__hero-badge-num">4.8★</span>
                            <span className="about__hero-badge-lbl">{translate("рейтинг в App Store")}</span>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    /* Draw Stats */
    _stats = () => {
        return (
            <section className="section section--tight">
                <div className="container">
                    <div className="about__stats">
                        {STATS.map((stat) => (
                            <div key={stat.l} className="about__stat">
                                <div className="about__stat-num">{stat.n}</div>
                                <div className="about__stat-lbl">{translate(stat.l)}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        )
    }

    /* Draw Mission */
    _mission = () => {
        return (
            <section className="section">
                <div className="container about__mission">
                    <div className="about__mission-media">
                        <img src="https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?w=900&q=80" alt="" />
                    </div>
                    <div className="about__mission-text">
                        <h2 className="about__h2">{translate("Наша миссия")}</h2>
                        <p>
                            {translate("Мы верим, что забота о себе не должна быть сложной. Раньше запись к мастеру означала звонки, ожидание ответа и неудобные часы. Bookify убирает эти барьеры: вся индустрия красоты и ухода — в одном приложении.")}
                        </p>
                        <p>
                            {translate("Клиент за минуту находит салон рядом, видит реальные цены, отзывы и свободное время. А салон получает поток клиентов и инструменты, чтобы управлять записями, не теряя ни одной заявки.")}
                        </p>
                        <div className="about__mission-points">
                            <div className="about__point">
                                <span className="about__point-ic"><Icon name="check" size={16} /></span>
                                {translate("Прозрачные цены и честные отзывы")}
                            </div>
                            <div className="about__point">
                                <span className="about__point-ic"><Icon name="check" size={16} /></span>
                                {translate("Запись 24/7 без звонков")}
                            </div>
                            <div className="about__point">
                                <span className="about__point-ic"><Icon name="check" size={16} /></span>
                                {translate("Поддержка клиентов и салонов")}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    /* Draw Values */
    _values = () => {
        return (
            <section className="section about__section-soft">
                <div className="container">
                    <div className="section__head about__values-head">
                        <div className="about__values-head-inner">
                            <h2 className="about__h2">{translate("Почему выбирают Bookify")}</h2>
                            <p className="about__muted">{translate("Сервис, который одинаково удобен для клиентов и для бизнеса")}</p>
                        </div>
                    </div>
                    <div className="about__values">
                        {VALUES.map((value) => (
                            <div key={value.t} className="about__value">
                                <span className="about__value-ic"><Icon name={value.icon} size={22} /></span>
                                <h3>{translate(value.t)}</h3>
                                <p>{translate(value.d)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        )
    }

    /* Draw Company */
    _company = () => {
        return (
            <section className="section">
                <div className="container">
                    <div className="about__company">
                        <div className="about__company-main">
                            <h2 className="about__h2">{translate("Реквизиты компании")}</h2>
                            <p className="about__company-lede">
                                {translate("Bookify развивается командой ТОО «SARY GROUP» в Алматы. По вопросам сотрудничества и подключения салонов — пишите и звоните, мы всегда на связи.")}
                            </p>
                            <dl className="about__reqs">
                                <div><dt>{translate("Юридическое лицо")}</dt><dd>ТОО «SARY GROUP»</dd></div>
                                <div><dt>{translate("БИН")}</dt><dd>240440023071</dd></div>
                            </dl>
                        </div>
                        <div className="about__contacts">
                            <h3>{translate("Контакты")}</h3>
                            <a className="about__contact" href="tel:+77071385100">
                                <span className="about__contact-ic"><Icon name="phone" size={18} /></span>
                                <span><b>+7 (707) 138-51-00</b><small>{translate("Отдел продаж")}</small></span>
                            </a>
                            <a className="about__contact" href="tel:+77064064599">
                                <span className="about__contact-ic"><Icon name="phone" size={18} /></span>
                                <span><b>+7 (706) 406-45-99</b><small>{translate("Поддержка салонов")}</small></span>
                            </a>
                            <a className="about__contact" href="mailto:info@bookify.kz">
                                <span className="about__contact-ic"><Icon name="mail" size={18} /></span>
                                <span><b>info@bookify.kz</b><small>{translate("Общие вопросы")}</small></span>
                            </a>
                            <a className="about__contact" href="https://maps.google.com/?q=БЦ+Quorum+Алматы" target="_blank" rel="noopener noreferrer">
                                <span className="about__contact-ic"><Icon name="pin" size={18} /></span>
                                <span><b>{translate("БЦ Quorum, Мамыр 1, 26, 508 кабинет")}</b><small>{translate("Алматы")}</small></span>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    /* Draw CTA */
    _cta = () => {

        /* Fields */
        const { navigate } = this.props

        return (
            <section className="section section--tight">
                <div className="container">
                    <div className="about__cta">
                        <div>
                            <h2>{translate("Готовы начать?")}</h2>
                            <p>{translate("Найдите услугу рядом или подключите свой салон к Bookify уже сегодня.")}</p>
                        </div>
                        <div className="about__cta-actions">
                            <button className="btn btn--lg" onClick={() => navigate("/")}>
                                {translate("Найти услугу")} <Icon name="arrow_right" size={16} />
                            </button>
                            <button className="btn btn--ghost btn--lg about__cta-ghost" onClick={() => navigate("/contacts")}>
                                {translate("Связаться с нами")}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    render = () => {
        return (
            <Block>
                <div className="page about">
                    {this._hero()}
                    {this._stats()}
                    {this._mission()}
                    {this._values()}
                    {this._company()}
                    {this._cta()}
                </div>
            </Block>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        lang: state.lang
    }
}

/* Export */
export default connect(mapStateToProps)(withRouter(About))
